import { StepItemProps, WorkflowItemProps } from "apis";
import { lazy } from "react";

export const PageAdminWorkflowStep = lazy(() => import("./List"));
export const PageAdminWorkflowStepCreate = lazy(() => import("./Add"));
export const PageAdminWorkflowStepUpdate = lazy(() => import("./Edit"));
export const PageAdminWorkflowStepProcessFlow = lazy(() => import("./ProcessFlow"));

export interface FormWorkflowStepValuesProps extends StepItemProps {
    beginStatusId?: number;
    endStatusId: number;
}